import { checkDefined } from 'faro-common-model';
export var RoleType;
(function (RoleType) {
    RoleType["SYSTEM"] = "SYSTEM";
    RoleType["CUSTOM"] = "CUSTOM";
    RoleType["INTERNAL"] = "INTERNAL";
})(RoleType || (RoleType = {}));
/**
 * System role names and ids
 *
 * NOTE: do not change this freely, it must match the values in the database
 */
export var SystemRoleName;
(function (SystemRoleName) {
    SystemRoleName["USER_ADMIN"] = "USER-ADMIN";
    SystemRoleName["EDITOR"] = "EDITOR";
    SystemRoleName["VIEWER"] = "VIEWER";
    SystemRoleName["DYNAMIC_FIELD_DEF_ADMIN"] = "DYNAMIC-FIELD-DEF-ADMIN";
    SystemRoleName["SNIPPET_ADMIN"] = "SNIPPET-ADMIN";
})(SystemRoleName || (SystemRoleName = {}));
export const SystemRoleNameToId = new Map([
    [SystemRoleName.USER_ADMIN, '6f63ed01-776b-4d10-b358-04bcc3734cb9'],
    [SystemRoleName.EDITOR, '16ecd399-25e4-44f4-8f64-9d1d6675aabe'],
    [SystemRoleName.VIEWER, '68a64219-0709-46e2-95f3-1316ebea087f'],
    [SystemRoleName.DYNAMIC_FIELD_DEF_ADMIN, 'e9be0bdc-b3f2-48ba-9441-0139d59c0e00'],
    [SystemRoleName.SNIPPET_ADMIN, 'e1c36179-87f1-42a0-9fe3-ed2805e8c7cd'],
]);
export var InternalRoleName;
(function (InternalRoleName) {
    InternalRoleName["DEFAULT_USER"] = "DEFAULT-USER";
})(InternalRoleName || (InternalRoleName = {}));
export const InternalRoleNameToId = new Map([
    [InternalRoleName.DEFAULT_USER, 'a8bcc849-b001-4583-8f16-c40514113b45'],
]);
/**
 * @return the built RoleDetail DTO
 */
export function toRole(roleDetail) {
    checkDefined(roleDetail.name, 'RoleDetail', 'name');
    return {
        id: roleDetail.id,
        name: roleDetail.name,
        description: roleDetail.description,
        type: roleDetail.type,
        deleted: roleDetail.deleted || false,
        created: roleDetail.created,
        updated: roleDetail.updated,
        updatedBy: roleDetail.updatedBy,
    };
}
//# sourceMappingURL=role-detail.js.map